import styled, { css } from "styled-components";
import {
  BRAND_DARKEST,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  TEXT_SECONDARY,
  WHITE
} from "@streeteasy/design-system/colors";
import Button from "@streeteasy/design-system/deprecated/actions/button";
import TextLink from "@streeteasy/design-system/deprecated/actions/text-link";
import FontAwesomeIcon from "@streeteasy/design-system/deprecated/Icons/FontAwesomeIcon";
import { Field } from "@streeteasy/design-system/form";
import { Combobox } from "@streeteasy/design-system/form/ComboboxField/";

import { smallScreen } from "src/shared/constants/screenSizes";

export const SearchModuleWrapper = styled.div`
  background: ${WHITE};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.16);
  display: flex;
  height: 106px;
  margin: 6px auto;
  max-width: 890px;
  padding: 16px;

  @media screen and (max-width: ${smallScreen}px) {
    align-items: center;
    flex-direction: column;
    height: auto;
    margin-bottom: 8px;
  }
`;

export const ListingsToggle = styled.div`
  background: ${GRAY_LIGHTEST};
  border: 1px solid ${GRAY_LIGHT};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  max-width: 106px;
  position: relative;
  width: 100%;

  &:after {
    background: ${BRAND_DARKEST};
    border-radius: 4px;
    content: "";
    display: block;
    height: 32px;
    left: 4px;
    position: absolute;
    right: 4px;
    top: 3px;
    transition: 0.5s;
    z-index: 10;

    @media screen and (max-width: ${smallScreen}px) {
      height: calc(100% - 6px);
      top: 3px;
      width: 96px;
    }

    ${props =>
      props.listingType === "sales" &&
      css`
        top: calc(50% + 1px);
        transition: 0.5s;

        @media screen and (max-width: ${smallScreen}px) {
          left: 50%;
        }
      `}
  }

  @media screen and (max-width: ${smallScreen}px) {
    flex-direction: row;
    max-width: 201px;
    margin-bottom: 4px;
    justify-content: space-around;
  }
`;

export const LinkToggle = styled(TextLink)`
  background: none;
  border: none;
  color: ${TEXT_SECONDARY};
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  height: 34px;
  line-height: 34px;
  position: relative;
  text-align: center;
  transition: 0.5s;
  z-index: 20;

  @media screen and (max-width: ${smallScreen}px) {
    padding: 7px 32px;
    height: auto;
    line-height: 24px;
  }

  ${props =>
    props.isActive &&
    css`
      color: ${WHITE};
      transition: 0.5s;
    `}
`;

export const LocationFilterWrapper = styled.div`
  border-right: 1px solid ${GRAY_LIGHT};
  max-width: 335px;
  padding: 5px 16px;
  width: 100%;

  @media screen and (max-width: ${smallScreen}px) {
    border-right: 0;
    max-width: 100%;
    padding-left: 0;
    padding-right: 0;
  }

  button {
    height: 40px;
  }

  #location-filter-widget-describedby-title {
    display: block;
    margin: 0 0 10px;
  }
`;

export const MaxPriceWrapper = styled.div`
  align-items: center;
  display: flex;
  max-width: inherit;
  padding: 5px 12px 5px 16px;
  position: relative;
  width: 100%;

  @media screen and (max-width: ${smallScreen}px) {
    margin-bottom: 16px;
    max-width: 100%;
    padding-left: 0;
    padding-right: ${props => (props.isWide ? "0" : "16px")};
    flex-wrap: wrap;
    align-items: baseline;
    height: ${props => (props.isWide ? "80px" : "124px")};
    justify-content: space-between;
    transition: 0.5s;
    padding: 10px 0 0;
  }
`;

export const PriceCombobox = styled(Combobox)`
  ul {
    max-height: 114px;
    overflow-y: auto;

    @media screen and (max-width: ${smallScreen}px) {
      max-height: 200px;
    }
  }
`;

export const PriceField = styled(Field)`
  margin-right: ${props => (props.isWide ? "0" : "80px")};
  padding-right: 10px;
  position: relative;
  transition: 0.5s;
  width: 100%;
  z-index: 20;

  @media screen and (max-width: ${smallScreen}px) {
    flex-basis: calc((100% - 16px) / 2);
    margin: 0;
    padding: 0;
  }
`;

export const CheckBoxWrapper = styled.div`
  align-items: center;
  height: 100%;
  margin: 0 5px 1px 0;
  max-width: 100px;
  overflow: hidden;
  padding: 31px 16px 0 0;
  position: absolute;
  right: 0;
  width: 100%;
  z-index: 10;

  &:after {
    background: ${WHITE};
    bottom: 0;
    content: "";
    left: 0;
    position: absolute;
    right: 100%;
    top: 0;
    transition: 0.5s;
  }

  @media screen and (min-width: ${smallScreen + 1}px) {
    ${({ isWide }) =>
      isWide &&
      css`
        &:after {
          right: 0;
        }
      `}
  }

  @media screen and (max-width: ${smallScreen}px) {
    border: none;
    height: 40px;
    margin: 0;
    max-width: inherit;
    padding: 0;
    top: calc(100% - 40px);

    &:after {
      bottom: 100%;
      right: 0;
    }

    ${({ isWide }) =>
      isWide &&
      css`
        &:after {
          bottom: 0;
        }
      `}
  }

  label {
    font-size: 14px;
    left: 0;
    margin-left: 4px;
    position: absolute;
    white-space: nowrap;

    @media screen and (max-width: ${smallScreen}px) {
      font-size: 16px;
    }

    &:hover {
      background: none;
    }
  }
`;

export const SearchButton = styled(Button)`
  font-size: 0;
  height: 66px;
  line-height: 0;
  margin: 4px 0;
  min-width: 64px;
  padding: 0 10px 7px;
  text-align: center;

  @media screen and (max-width: ${smallScreen}px) {
    font-size: 12px;
    line-height: 48px;
    height: 48px;
    margin-bottom: 7px;
    min-width: 198px;
    padding: 0;
  }
`;

export const SearchIcon = styled(FontAwesomeIcon)`
  @media screen and (max-width: ${smallScreen}px) {
    font-size: 12px;
    margin-right: 8px;
  }
`;
